// extracted by mini-css-extract-plugin
export default {"container":"PresenceAvatarStack-module__container--ZuXG4","avatar":"PresenceAvatarStack-module__avatar--k9LVC"};